/**
 * Las secciones del portal y qué pantallas agrupa cada una (plan del portal, D2).
 * Aparte de `PortalNav` para poder probarlas sin renderizar.
 */
import { Home, FolderOpen, CalendarDays, Network, Users } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Seccion {
  rotulo: string
  rotuloCorto?: string
  icono: LucideIcon
  /** La primera es a la que lleva la pestaña; todas la dejan marcada. */
  rutas: { ruta: string; rotulo: string }[]
  /** Solo se muestra a quien tiene equipo (jefatura o suplente): `tiene_equipo` del inicio. */
  soloConEquipo?: boolean
}

export const SECCIONES_DEL_PORTAL: Seccion[] = [
  { rotulo: 'Inicio', icono: Home, rutas: [{ ruta: '', rotulo: 'Inicio' }, { ruta: 'ficha', rotulo: 'Mi ficha' }] },
  {
    rotulo: 'Documentos', icono: FolderOpen,
    rutas: [
      { ruta: 'documents', rotulo: 'Carpeta digital' },
      { ruta: 'payslips', rotulo: 'Liquidaciones' },
      { ruta: 'signatures', rotulo: 'Pendientes de firma' },
    ],
  },
  {
    rotulo: 'Vacaciones y permisos', rotuloCorto: 'Vacaciones', icono: CalendarDays,
    rutas: [{ ruta: 'time-off', rotulo: 'Vacaciones y permisos' }],
  },
  { rotulo: 'Organigrama', icono: Network, rutas: [{ ruta: 'org-chart', rotulo: 'Organigrama' }] },
  // Sección propia y no subpestaña de «Organigrama»: ahí nadie la encontraba, y es
  // donde la jefatura resuelve las solicitudes de su equipo (#1473).
  { rotulo: 'Mi equipo', icono: Users, rutas: [{ ruta: 'my-team', rotulo: 'Mi equipo' }], soloConEquipo: true },
]

/** El tramo de la ruta dentro del portal: `''` para el inicio, `'payslips'`… */
export function tramo(pathname: string, base: string): string {
  return pathname.slice(base.length).replace(/^\/+|\/+$/g, '').split('/')[0] ?? ''
}

export function seccionActiva(pathname: string, base: string): Seccion | undefined {
  const actual = tramo(pathname, base)
  return SECCIONES_DEL_PORTAL.find(s => s.rutas.some(r => r.ruta === actual))
}
